// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.refer-modal-box.wui-modal-body {
  padding: 0px;
  position: relative;
}
.refer-modal-box.wui-modal-body .table-selected-rows-content {
  position: absolute;
  bottom: 0px;
  left: 16px;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
          align-items: center;
  width: 150px;
  -webkit-justify-content: space-between;
          justify-content: space-between;
}
.refer-modal-box.wui-modal-body .table-selected-rows-content > span {
  line-height: 1;
}
.refer-modal-box.wui-modal-body .table-selected-rows-content .wui-button {
  padding: 0;
}
.refer-modal-box.wui-modal-body .wui-tabs {
  height: 100%;
}
.refer-modal-box.wui-modal-body .wui-tabs .wui-tabs-bar {
  margin-bottom: 0;
}
.refer-modal-box.wui-modal-body .wui-tabs .wui-tabs-tabpane {
  height: 100%;
}
.refer-modal-box.wui-modal-body .selected-tips {
  display: none;
}
.refer-modal-box.wui-modal-body .yb-convenient-query {
  max-height: 200px;
  overflow-y: scroll;
}
.refer-modal-box.wui-modal-body .yb-convenient-query .hide-botton-line:last-child {
  margin-bottom: 0px !important;
}
.refermodal-switch-icon {
  float: right;
  font-weight: 100;
  color: #999;
  margin-right: 15px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/ReferInputPcNew/components/ReferModal/index.less"],"names":[],"mappings":"AACA;EACE,YAAA;EACA,kBAAA;AAAF;AAFA;EAII,kBAAA;EACA,WAAA;EACA,UAAA;EACA,qBAAA;EAAA,aAAA;EACA,2BAAA;UAAA,mBAAA;EACA,YAAA;EACA,sCAAA;UAAA,8BAAA;AACJ;AAAI;EACE,cAAA;AAEN;AAdA;EAeM,UAAA;AAEN;AAjBA;EAoBI,YAAA;AAAJ;AApBA;EAsBM,gBAAA;AACN;AAvBA;EAyBM,YAAA;AACN;AA1BA;EAkCI,aAAA;AALJ;AA7BA;EAsCI,iBAAA;EACA,kBAAA;AANJ;AAjCA;EAyCM,6BAAA;AALN;AAUA;EACE,YAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AARF","sourcesContent":["\n.refer-modal-box.wui-modal-body {\n  padding: 0px;\n  position: relative;\n  .table-selected-rows-content {\n    position: absolute;\n    bottom: 0px;\n    left: 16px;\n    display: flex;\n    align-items: center;\n    width: 150px;\n    justify-content: space-between;\n    &>span {\n      line-height: 1;\n    }\n    .wui-button {\n      padding: 0;\n    }\n  }\n\n  .wui-tabs {\n    height: 100%;\n    .wui-tabs-bar {\n      margin-bottom: 0;\n    }\n    .wui-tabs-tabpane {\n      height: 100%;\n      // display: flex;\n      // flex-direction: column;\n    }\n\n\n  }\n\n  .selected-tips {\n    display: none;\n  }\n\n  .yb-convenient-query {\n    max-height: 200px;\n    overflow-y: scroll;\n    .hide-botton-line:last-child {\n      margin-bottom: 0px !important;\n    }\n  }\n}\n\n.refermodal-switch-icon {\n  float: right;\n  font-weight: 100;\n  color: #999;\n  margin-right: 15px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
